import Nav from './Nav';


function App() {
  return (
    <div className="page-content">
        <Nav/>
        <main>
            
            <section className="body-columns">
                <div className="main-image"><img className="clipped-image" src={require('../images/cutting-sourdough-country-loaf - vertical.jpg')} alt="Cutting a sourdough country loaf" /></div>
                <div className="content-columns">
                    <div className="text-column">
                        <h1>One Thing Kneaded</h1>
                        <p>Cottage bakery in Normal, Illinois. I specialize in sourdough breads, pastries, cookies, and sharing the love of baking with all.</p>
                        
                    </div>
                    <div className="image-columns">
                        <div className="image-column">
                            <a href="/order"><img src={require('../images/sourdough-country-loaf.jpg')} alt="A loaf of sourdough bread" /></a>
                            <p><a href="/order">Order</a></p>
                        </div>
                        <div className="image-column">
                            <a href="/classes"><img src={require('../images/mason-jar-with-flour.jpg')} alt="A mason jar half-full of flour on a scale" /></a>
                            <p><a href="/classes">Classes</a></p>
                        </div>
                    </div>
                    <div className="logo-column">
                        <img src={require("../images/OTK_logomark_lightgreen.png")} alt="One Thing Kneaded icon" />
                    </div>
                </div>
            </section>
        </main>
    </div>
  );
}

export default App;
